<script setup>
import TD from "@/Components/Table/Element.vue";

import SettingsLayout from "@/Layouts/Settings.vue";
import Input from "@/Components/Settings/Input.vue";
import Select from "@/Components/Select.vue";
import Label from "@/Components/Settings/Label.vue";
import HeaderLink from "@/Components/Settings/HeaderLink.vue";
import HeaderButton from "@/Components/Settings/HeaderButton.vue";
import Heading from "@/Components/Settings/Heading.vue";
import { Head, useForm } from "@inertiajs/inertia-vue3";
import { ref, onUnmounted } from "vue";
import { Inertia } from "@inertiajs/inertia";

const page_name = "Urlaub";

let props = defineProps({
    practitioners: Object,
    errors: Object,
});

const form = useForm({
    practitioner_id: props.practitioners[0].id,
    start: null,
    start_time: null,
    end: null,
    end_time: null,
    fullday: true,
    annotation: "",
});
let saveBtnClicked = false;

//onUnmounted(
//    Inertia.on("before", (e) => {
//        if (form.isDirty && !saveBtnClicked) {
//            return confirm(
//                "Sie haben ungespeicherte Eingaben. Wollen Sie diese Seite wirklich verlassen?"
//            );
//        }
//    })
//);

function submitForm() {
    saveBtnClicked = true;
    form.post("/employeeVacations");
}

function changeType() {
    form.reset("start", "end");
}
</script>

<template>
    <SettingsLayout>
        <Head :title="`${page_name} - Grundeinstellungen`" />

        <template #breadcrumb>{{ page_name }}</template>
        <template #controls>
            <HeaderLink class="mr-3" href="/" type="close"
                >Schließen</HeaderLink
            >
            <HeaderButton @click="submitForm()">Speichern</HeaderButton>
        </template>
        <Heading title="Neuen Behandlerurlaub anlegen" />

        <p class="max-w-2xl text-sm text-oteoText mb-9">
            Separater Urlaub der einzelnen Mitarbeiter.
        </p>

        <div class="grid grid-cols-2 max-w-3xl gap-5 mt-8">
            <div class="">
                <Label> Bitte wählen Sie eine/n Mitarbeiter.</Label>

                <Select
                    class="w-full max-w-sm mr-4"
                    v-model="form.practitioner_id"
                >
                    <option
                        v-for="practitioner in practitioners"
                        :key="practitioner.id"
                        :value="practitioner.id"
                    >
                        {{
                            `${practitioner.firstname} ${practitioner.lastname}`
                        }}
                    </option>
                </Select>
            </div>
        </div>
        <div class="grid grid-cols-2 max-w-3xl gap-5 mt-8">
            <div class="">
                <Label class="mr-4 inline-block"> Ganztägig </Label>
                <input
                    @change="changeType()"
                    v-model="form.fullday"
                    type="checkbox"
                />
                <div class="mt-2 text-red-600 text-sm" v-if="errors.fullday">
                    {{ errors.fullday }}
                </div>
            </div>
        </div>

        <div class="grid grid-cols-2 max-w-3xl gap-5 mt-8">
            <div class="">
                <Label> Beginn </Label>

                <Input
                    v-model="form.start"
                    class="w-full"
                    :min="
                        form.fullday
                            ? new Date().toISOString().split('T')[0]
                            : new Date().toISOString().split('T')[0] +
                              'T00:00:00'
                    "
                    :type="form.fullday ? 'date' : 'datetime-local'"
                />
                <div class="mt-2 text-red-600 text-sm" v-if="errors.start">
                    {{ errors.start }}
                </div>
            </div>
        </div>

        <div class="grid grid-cols-2 max-w-3xl gap-5 mt-8">
            <div class="">
                <Label> Ende </Label>

                <Input
                    v-model="form.end"
                    class="w-full"
                    :min="form.start"
                    @focus="
                        () => {
                            if (!form.end) {
                                form.end = form.start;
                            }
                        }
                    "
                    :type="form.fullday ? 'date' : 'datetime-local'"
                />
                <div class="mt-2 text-red-600 text-sm" v-if="errors.end">
                    {{ errors.end }}
                </div>
            </div>
        </div>

        <div class="grid grid-cols-2 max-w-3xl gap-5 mt-8">
            <div class="">
                <Label>Anmerkungen</Label>
                <Input v-model="form.annotation" class="w-full" />
                <div class="mt-2 text-red-600 text-sm" v-if="errors.annotation">
                    {{ errors.annotation }}
                </div>
            </div>
        </div>
    </SettingsLayout>
</template>
